import { hFetch as hFetchOld } from './hFetch';
import { hFetch } from '@/lib/hfetch';
import type { TeamMemberEntity } from './entity_types/TeamMember';
import type { TeamEntity } from './entity_types/Team';

export type BillingSessionResponse = {
  session: string;
};

export const getBillingSession = async () => {
  return await hFetch<BillingSessionResponse>({ url: '/api/team/billing_session' });
};

export const listTeamUsers = async () => {
  return await hFetchOld({ url: '/api/team' });
};

export const getTeam = async () => {
  return (await hFetchOld({ url: '/api/team' })) as { record: TeamEntity; team_members: TeamMemberEntity[] };
};

export const updateTeam = async (params: Partial<TeamEntity>) => {
  return await hFetchOld<{ record: TeamEntity }>({
    url: '/api/team',
    method: 'PUT',
    payload: params,
  });
};
